@for (item of banners; track $index) {
    <div>
        {{item.text}}
    </div>
}